/* HeyBear · Stockist enquiry (Shopify contact form): validation, sent message, and #stockist deep link. */
HB.section('stockist', function (root) {
  HB.reveal(root);
  var form = root.querySelector('#skForm'), m = root.querySelector('#skStatus'); if (!form) return;
  form.noValidate = true;
  var st = m.getAttribute('data-state');
  if (st && location.hash === '#skForm') { m.textContent = st === 'ok' ? m.getAttribute('data-ok') : st; setTimeout(function () { form.scrollIntoView(); }, 300); }
  var onSubmit = function (e) {
    var v = function (id) { return (form.querySelector(id).value || '').trim(); };
    if (!v('#skBiz') || !v('#skName')) { e.preventDefault(); m.textContent = m.getAttribute('data-need-names'); return; }
    if (!HB.emailOk(v('#skEmail'))) { e.preventDefault(); m.textContent = m.getAttribute('data-bad-email'); return; }
  };
  form.addEventListener('submit', onSubmit);
  if (location.hash === '#stockist') {
    var go = function () { var s = document.getElementById('stockist'); if (s) s.scrollIntoView(); };
    setTimeout(go, 100); setTimeout(go, 900);
  }
  return function () { form.removeEventListener('submit', onSubmit); };
});
